/** Notifies the admin host to pause full-schema UPDATE_PROPS during drag/resize. */

export function notifyPreviewLayoutDrag(active) {
  if (typeof window === "undefined" || !window.parent) return;
  window.parent.postMessage(
    { type: "preview_layout_drag", active: Boolean(active) },
    "*"
  );
}

export function isPreviewLayoutDragActive() {
  if (typeof window === "undefined") return false;
  return Boolean(window.__WEUPSELL_PREVIEW_LAYOUT_DRAGGING__);
}
